require('../bootstrap')
import Vue from 'vue';
const marquee = require('jquery.marquee')
const slick = require('slick-carousel')
const ClipboardJS = require('clipboard')
const retinajs = require('retinajs')
const lozad = require('lozad')
const EXIF = require('exif-js')
const FormDropzone = require('./components/formDropzone/FormDropzone.vue').default
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

require('../global/_global')
require('../global/LoaderModule')
require('../global/FormHelpers')
require('../global/LoginModule')
require('../app/dms')
require('../app/userFollow')
require('../gate/GateStepsModule')

// New Vue Components Refactored
window.eventBus = new Vue();
require('@/components/_index')
require('@/components/Profile/Card')
require('@/components/Search/Index')
require('@/components/Lists/Index')
require('@/components/Lists/Show')
require('@/components/Destinations/Index')
require('@/components/Posts/Index')
require('@/components/Referrals/Index')
require('@/components/Notifications/_index')
require('@/components/SuggestSpot/Index')
require('@/components/Booking/Index')

window.EXIF = EXIF
;(function($) {

  $(document).ready(function ($) {

    LoaderModule.init()
    LoginModule.init()

    // if (document.querySelector('body.profile')) {
    //   ProfileImageUpload.init()
    // }

    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();

  })

  //UPDATE THE DOM BASED ON WINDOW SIZE
  function mobileMoves() {
      var vp = viewport().width

      if ($('.map-sidebar').length) {
          $('.main-footer').appendTo('.map-sidebar')
      }

      // globale
      if (vp < 1170) {
          // if ($('.hp-grid-section').length) {
          // 	$('.hp-grid-section').each(function() {
          // 		$(this).find('.grid-pullout').prependTo($(this));
          // 	});
          // }
      }

      //recommendation / profile .....
      if (vp < 960) {

          if ($('.rec-sidebar').length) {
              if ($('.spot-paywall').length) {
                  $('.rec-sidebar').insertBefore('.spot-paywall')
                  $('.rec-sidebar').insertBefore('.rec-content')
              } else {
                  $('.rec-sidebar').insertBefore('.rec-content')
              }
          }

          if ($('.profile-sidebar').length) {
              $('.profile-sidebar').insertAfter('.profile-cover')
          }
      } else {
          if ($('.rec-sidebar').length) {
              $('.rec-sidebar').insertBefore('.rec-main')
          }

          if ($('.profile-sidebar').length) {
              $('.profile-sidebar').insertBefore('.profile-main')
          }
      }
  }

  var sticky = false
  var diff = 0
  var nav = 0

  window.stickMe = function () {
    var scroll = $(window).scrollTop() + viewport().height - diff
    var scrollTop = $(window).scrollTop()

    diff = 0

    $('.sticky').each(function () {
      if (
          scrollTop >
          $(this)
              .parent()
              .offset().top -
          diff &&
          scrollTop <
          $(this)
              .parent()
              .offset().top +
          $(this)
              .parent()
              .outerHeight()
      ) {
        sticky = $(this)

        $('.sticky')
            .not(sticky)
            .removeClass('fixed-top')
      }
    })

    if (sticky) {
      var stickyHeight = sticky.outerHeight(true)
      var par = sticky.parent()
      var parTop = par.offset().top + parseInt(par.css('padding-top'))
      var parBot = parTop - parseInt(par.css('padding-top')) + par.outerHeight()
      var isFixed = $('.sticky.fixed').length
      var parSticky = parTop + stickyHeight
      var stickyTop = sticky.offset().top
      var paddingLeft = sticky.css('padding-left')

      sticky.outerWidth(par.outerWidth())
      sticky.css('padding-left', paddingLeft)

      if (stickyHeight > viewport().height) {
        if (scroll > parSticky && scroll < parBot) {
          sticky.addClass('fixed')
          sticky.removeClass('stuck')
        } else if (scroll > parBot) {
          sticky.addClass('stuck')
          sticky.removeClass('fixed')
        } else if (stickyTop < parTop && sticky.hasClass('fixed')) {
          sticky.removeClass('fixed')
          sticky.removeClass('stuck')
        } else {
          sticky.removeClass('fixed')
          sticky.removeClass('stuck')
        }
      } else {
        if (
            scrollTop > parTop - diff &&
            scrollTop < parBot - stickyHeight - diff
        ) {
          sticky.addClass('fixed-top')
          sticky.removeClass('stuck')
        } else if (scrollTop >= parBot - stickyHeight - diff) {
          sticky.addClass('stuck')
          sticky.removeClass('fixed-top')
        } else {
          sticky.removeClass('fixed-top')
          sticky.removeClass('stuck')
        }
      }
    }
  }

  function stickExtras(ele) {
    var scrollMid = $(window).scrollTop()
    var par = ele.parent()
    var parHeight = par.outerHeight() - 50 + par.offset().top
    var tar = par.offset().top - 96

    if (window.viewport().width > 960) {
      if (scrollMid > tar) {
        if (scrollMid + 66 + ele.outerHeight() > parHeight) {
          ele.addClass('stuck').removeClass('fixed')
        } else {
          ele.addClass('fixed').removeClass('stuck')
        }
      } else {
        ele.removeClass('fixed').removeClass('stuck')
      }
    }
  }

  function hideRecButtons() {
    var tar = $('.rec-main').offset().top + $('.rec-main').outerHeight()
    var scroll = $(window).scrollTop() + window.viewport().height

    if (window.viewport().width < 960) {
      if (scroll > tar) {
        $('.buttons').addClass('hide')
      } else {
        $('.buttons').removeClass('hide')
      }
    }
  }

  // global

  //OPEN SEARCH MODAL
  $('.search-trigger').on('click', function () {

    $('.search-modal').fadeToggle()
    // tell search drawer to load initial content
    window.search.isActive = !window.search.isActive

    if ($(this).hasClass('active')) {
      $('.mobile-menu').removeClass('inactive')
    } else {
      $('.mobile-menu').addClass('inactive')
    }

    $(this)
        .toggleClass('active')
        .siblings()
        .removeClass('active')

    $('.mob-cities').fadeOut()
    $('.mob-profile').fadeOut()
    $('.mobile-shade').fadeOut()

    if (window.viewport().width < 801) {

      $('.notification-centre').fadeOut();

    }

  })

  //CLOSE SEARCH MODAL
  $('.search-shade, .search-close').on('click', function () {
    $('.search-modal').fadeOut()
  })

  $(document).on('keydown', '#js-search input', function (event) {
    if (event.keyCode == 13) {
      event.preventDefault()
      $('#js-search input').blur()
    }
  })

  $('.cities-trigger').on('click', function () {
    // if (!$('.gate-mobile-menu').length) {

    $('.mob-cities').fadeToggle()

    // setTimeout(mobCitiesInit, 1)

    if ($(this).hasClass('active')) {
      // $('.mobile-menu').removeClass('inactive')
      $('.mobile-shade').fadeOut()
    } else {
      // $('.mobile-menu').addClass('inactive')
      $('.mobile-shade').fadeIn()
    }

    $(this).toggleClass('active').siblings().removeClass('active')
    $('.mob-profile').fadeOut()
    $('.search-modal').fadeOut()
    // }
  })

  $('.profile-trigger').on('click', function () {
    $('.mob-profile').fadeToggle()

    if ($(this).hasClass('active')) {
      $('.mobile-menu').removeClass('inactive')
      $('.mobile-shade').fadeOut()
    } else {
      $('.mobile-menu').addClass('inactive')
      $('.mobile-shade').fadeIn()
    }

    $(this)
        .toggleClass('active')
        .siblings()
        .removeClass('active')
    $('.mob-cities').fadeOut()
    $('.search-modal').fadeOut()
  })

  $('.mobile-shade').on('click', function () {
    $(this).fadeOut()
    $('.mob-cities, .mob-profile').fadeOut()
    $('.mobile-menu')
        .removeClass('inactive')
        .children()
        .removeClass('active')
  })

  $('.city-more-cta').on('click', function () {
    $('.city-content-wrap').height($('.city-content-wrap').height())
    $('.city-content-init').hide()
    $('.city-content-hidden').show()
    $('.city-content-wrap').height($('.city-content-hidden').height() + 15)
  })

  $('.city-less-cta').on('click', function () {
    $('.city-content-wrap').height($('.city-content-init').height() + 15)
    $('.city-content-init').show()
    $('.city-content-hidden').hide()
  })

  //CITY GATE

  if ($('.city-grid-gate').length) {
    $(window).on('load', function () {
      var $this = $('.city-grid-gate')
      var par = $this.parent()
      var offset = par.outerHeight() / 2
      var shade = $this.find('.city-grid-gate__shade')
      var padBot =
          $this.outerHeight() - offset + parseInt(par.css('padding-top')) * 2

      if (par.hasClass('hp-slider')) {
        par.css('padding-bottom', padBot + 'px')
      } else if (par.hasClass('post-comments-wrap')) {

        var padding = parseInt($('.blog-single__comments').css('padding-top')) + parseInt($('.blog-single__comments').css('padding-bottom'));
        par.height($this.outerHeight() + $('.blog-single__comments .top').outerHeight(true) + padding + 80)
        $('.blog-single__comments').height(par.height());

      } else {
        par.height($this.outerHeight() + par.height() / 2)
      }

      if (par.hasClass('post-comments-wrap')) {

        $this.css('top', $('.blog-single__comments .top').outerHeight(true) + parseInt($('.blog-single__comments').css('padding-top')) + 80 + 'px');
        shade.height(par.outerHeight() - 1).css('top', (($('.blog-single__comments .top').outerHeight(true) + parseInt($('.blog-single__comments').css('padding-top')) + 80) * -1) + 'px')

      } else {

        $this.css('top', offset + 'px')
        shade.height(par.outerHeight() - 1).css('top', '-' + offset + 'px')

      }
    })
  }

  // homepage

  //SWITCH HERO POST AUTOMATICALLY
  var hpHeroSwitcher
  if ($('.hp-hero').length) {
    if (window.viewport().width > 1170) {
      hpHeroSwitcher = setInterval(function () {
        var next = $('.feature-post.active').next()

        if (next.length) {
          $('.feature-post.active')
              .removeClass('active')
              .next()
              .addClass('active')
          $('.hero-button.active')
              .removeClass('active')
              .next()
              .addClass('active')
        } else {
          $('.feature-post.active')
              .removeClass('active')
              .siblings()
              .first()
              .addClass('active')
          $('.hero-button.active')
              .removeClass('active')
              .siblings()
              .first()
              .addClass('active')
        }
      }, 5000)
    }
  }

  //SWITCH HERO POST ON BUTTON CLICK
  $('.hero-button').on('click', function () {
    if (window.viewport().width > 960) {
      var tar = $(this).data('id')
      $(this)
          .addClass('active')
          .siblings()
          .removeClass('active')
      $('#featured-' + tar)
          .addClass('active')
          .siblings()
          .removeClass('active')
      if (window.viewport().width > 960) {
        clearInterval(hpHeroSwitcher)
      }
    } else {
      var tar = $(this).data('slick')
      $(this)
          .addClass('active')
          .siblings()
          .removeClass('active')
      $('.feature-posts').slick('slickGoTo', tar)
    }
  })

  var unmovedCities = true

  function moveTrendingCities() {
    var cities = $('.desktop-cities').children()
    var counter = 0

    if (unmovedCities) {
      unmovedCities = false

      cities.each(function () {
        if (counter < cities.length / 2) {
          $(this).appendTo('#mob-cities-1')
        } else {
          $(this).appendTo('#mob-cities-2')
        }

        counter++
      })

      $('#mob-cities-1 a').each(function () {
        var extraCity = $(this).clone()
        extraCity.appendTo('#mob-cities-1')
      })

      $('#mob-cities-2 a').each(function () {
        var extraCity = $(this).clone()
        extraCity.appendTo('#mob-cities-2')
      })

      $('#mob-cities-1').marquee({
        //duration in milliseconds of the marquee
        duration: 20000,
        //gap in pixels between the tickers
        gap: 0,
        //time in milliseconds before the marquee will start animating
        delayBeforeStart: 0,
        //'left' or 'right'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
        startVisible: true,
      })

      $('#mob-cities-2').marquee({
        //duration in milliseconds of the marquee
        duration: 20000,
        //gap in pixels between the tickers
        gap: 0,
        //time in milliseconds before the marquee will start animating
        delayBeforeStart: 0,
        //'left' or 'right'
        direction: 'right',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
        startVisible: true,
      })
    }
  }

  function destinationMarquee() {
    if (window.viewport().width < 600) {
      $('.destination-marquee').marquee({
        duration: 20000,
        gap: 0,
        delayBeforeStart: 0,
        direction: 'right',
        duplicated: true,
        startVisible: true,
      })
    }
  }

  $('.city-scroll-cta').on('click', function () {
    $('body, html').animate({
      scrollTop:
          $('.city-intro')
              .next()
              .offset().top - 66,
    })
  })

  function heroSliderInit() {
    $('.feature-posts:not(.slick-initialized)').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      //fade: true,
      rows: 0,
    })

    $('.feature-posts').on('beforeChange', function (
        event,
        slick,
        currentSlide,
        nextSlide
    ) {
      $('#hero-button-' + nextSlide)
          .addClass('active')
          .siblings()
          .removeClass('active')
    })
  }

  function recSliderInit() {
    if (window.viewport().width <= 960) {
      $('.rec-gallery img.gallery-image')
          .first()
          .width('calc(100vw - 60px)')
    } else {
      $('.rec-gallery img.gallery-image')
          .first()
          .width($('.rec-content').width())
    }

    $('.rec-gallery:not(.teaser)').slick({
      variableWidth: true,
      rows: 0,
      infinite: false,
      prevArrow:
          '<span class="slick-prev slick-arrow"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      nextArrow:
          '<span class="slick-next slick-arrow"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
    })

    $('.rec-gallery.teaser').slick({
      variableWidth: true,
      rows: 0,
      infinite: false,
      swipe: false,
      prevArrow: false,
      nextArrow: false
    })
  }

  $('.js-scroll-to-review').on('click', function () {
    const reviewId = $(this).attr('review-id')

    $('.hero-gallery-modal').fadeOut()

    eventBus.$emit('goToReview', reviewId)
  })

  $('.js-gallery-trigger').on('click', function () {

    const galleryIndex = $(this).attr('data-index')

    $('.hero-gallery-modal').fadeIn()


    gallerySliderInit(galleryIndex)
  })

  function gallerySliderInit(galleryIndex = null) {

    const $gallery = $('.hero-gallery-images')
    const total = $('.gallery-image').length

    $('#total-images').text(total)

    if (!$gallery.hasClass('slick-initialized')) {
      $gallery.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        fade: true,
        rows: 0,
        dots: true,
      })

      $('.hero-next').on('click', function () {
        $gallery.slick('slickNext')
      })
      $('.hero-prev').on('click', function () {
        $gallery.slick('slickPrev')
      })

      $gallery.on('beforeChange', function (
          event,
          slick,
          currentSlide,
          nextSlide
      ) {
        var num = nextSlide + 1

        $('.hero-gallery-modal #current-image').text(num)
        $('.hero-gallery-modal #slide-content-' + num)
            .addClass('active')
            .siblings()
            .removeClass('active')

        retinajs()
      })

      setTimeout(function () {
        retinajs()
      }, 300)
    }


    $gallery.slick('slickGoTo', parseInt(galleryIndex))
  }

  var touchTracker = false
  var touchMove = 0
  var citiesX = 0
  var newMove = 0
  var touchTimer
  var timerCounter = 0

  $('#mob-cities-1, #mob-cities-2, .destination-marquee').on('touchstart', function (e) {
    if (window.viewport().width < 600) {
      e.preventDefault()

      //pause marquee
      $(this).marquee('pause')

      //get starting touch point
      touchTracker = e.touches[0].clientX

      //get marquee translateX value
      var matrix = $(this)
          .css('transform')
          .replace(/[^0-9\-.,]/g, '')
          .split(',')
      citiesX = parseInt(matrix[12]) || parseInt(matrix[4])

      //click timer
      touchTimer = setInterval(function () {
        timerCounter++
      }, 100)
    }
  })

  $('#mob-cities-1, #mob-cities-2, .destination-marquee').on('touchmove', function (e) {
    if (window.viewport().width < 600) {
      e.preventDefault()

      //track difference between starting touch point and current touch point.
      touchMove = touchTracker - e.touches[0].clientX

      //invert touch change and speed it up by 50%
      touchMove = touchMove * -1 * 1.5

      //add the touch change to the current translateX value
      newMove = (citiesX || 0) + touchMove

      //apply the new translateX value
      $(this).css('transform', 'translateX(' + newMove + 'px)')
      $(this)[0].style.display = 'inline-block'
      $(this)[0].offsetHeight // no need to store this anywhere, the reference is enough
      $(this)[0].style.display = ''
    }
  })

  $('#mob-cities-1, #mob-cities-2, .destination-marquee').on('touchend', function (e) {
    if (window.viewport().width < 600) {
      e.preventDefault()

      //click link if short touch
      if (timerCounter < 1) {
        e.target.click()
      }

      //resume marquee
      $(this).marquee('resume')

      //reset touch values for next touch
      touchMove = 0
      touchTracker = false
      newMove = 0

      //stop click timer
      clearInterval(touchTimer)
      timerCounter = 0
    }
  })

  if ($('.city-tips-section').length) {
    var top = $('.city-tips-wrap').outerHeight() / 2
    $('.city-tips-title, .city-tips-info').css('top', top + 'px')
  }

  $('.city-tips-cta').on('click', function () {
    if (!$(this).hasClass('active')) {
      $(this)
          .addClass('active')
          .next()
          .slideDown()
          .parent()
          .siblings()
          .find('.city-tips-cta')
          .removeClass('active')
          .next()
          .slideUp()
    } else {
      $(this)
          .removeClass('active')
          .next()
          .slideUp()
    }
  })

  // This probably are used only on the map not sure, but is DEPRECATED in that place
  // $('.map-cats .filter-toggle').not('on-vue').on('click', function () {
  //   $('.map-sidebar').toggleClass('filtered')
  // })

  // This probably are used only on the map not sure, but is DEPRECATED in that place
  $('.tags-edit').not('on-vue').on('click', function () {
    $('.map-sidebar').addClass('filtered')
  })

  function cityMarqueeCheck() {
    var tar = $('#city-main-title')
    var par = $('#city-main-title-wrap')

    if (!par.hasClass('marquee-mode')) {
      if (tar.outerWidth() > par.outerWidth()) {
        par.addClass('marquee-mode')
        $('.city-title-marquee').marquee({
          //duration in milliseconds of the marquee
          duration: 15000,
          //gap in pixels between the tickers
          gap: 0,
          //time in milliseconds before the marquee will start animating
          delayBeforeStart: 0,
          //'left' or 'right'
          direction: 'left',
          //true or false - should the marquee be duplicated to show an effect of continues flow
          duplicated: true,
          startVisible: true,
        })
      } else {
        par.removeClass('marquee-mode')
      }
    }
  }


  $(document).not('.on-vue').on('click', '.more-checks-toggle', function () {
    $(this)
        .toggleClass('active')
        .prev()
        .slideToggle()
  })

  // $('.map-sort-cta').on('click', function () {
  //   $(this)
  //       .parent()
  //       .toggleClass('active')
  // })

  // $('.mob-map-trigger').on('click', function () {
  //   $(this).slideUp(function () {
  //     $('.map-main').addClass('show')
  //     alert("")
  //     $('.mob-map-controls').addClass('show')
  //     $('#mob-map-trigger').addClass('active')
  //   })
  // })

  // $('.mob-map-controls span').on('click', function () {
  //   $(this)
  //       .addClass('active')
  //       .siblings()
  //       .removeClass('active')
  //
  //   if ($(this).data('target') == 'map') {
  //     $('.map-main').addClass('show')
  //   } else {
  //     $('.map-main').removeClass('show')
  //   }
  // })

  $('.map-sidebar').scroll(function () {
    $('#mob-list-trigger').addClass('active')

    // if ($('.map-sidebar').scrollTop() > ($(".map-list").outerHeight() - $('.map-sidebar').outerHeight())) {

    //   $('.mob-map-controls').removeClass('show');

    // } else {

    //   $('.mob-map-controls').addClass('show');

    // }
  })

  $('.rec-sidebar .extras-button').on('click', function () {
    $('.rec-sidebar .extras-modal').fadeIn()
  })

  $('.rec-sidebar .extras-modal-close').on('click', function () {
    $('.rec-sidebar .extras-modal').fadeOut()
  })

  $('.profile-item h2').on('click', function () {
    $(this)
        .toggleClass('active')
        .next()
        .slideToggle()
  })

  $('.profile-item-list-trigger').on('click', function () {
    $(this)
        .toggleClass('active')
        .next()
        .slideToggle()
  })

  // $(document).on('click', '.activity-item-more', function () {
  //   var startHeight = $(this)
  //       .parents('.activity-item-content')
  //       .outerHeight()
  //   var endHeight
  //
  //   $(this)
  //       .parents('.activity-item-content')
  //       .outerHeight(startHeight)
  //       .find('.activity-item-content-extra')
  //       .show()
  //   $(this)
  //       .parent()
  //       .hide()
  //   endHeight = $(this)
  //       .parents('.activity-item')
  //       .find('.activity-item-content-extra')
  //       .get(0).scrollHeight
  //   $(this)
  //       .parents('.activity-item-content')
  //       .outerHeight(endHeight)
  // })
  //
  // $(document).on('click', '.activity-item-less', function () {
  //   var endHeight = $(this)
  //       .parents('.activity-item-content-extra')
  //       .prev()
  //       .outerHeight()
  //   $(this)
  //       .parents('.activity-item-content-extra')
  //       .prev()
  //       .show()
  //   $(this)
  //       .parents('.activity-item-content-extra')
  //       .hide()
  //   $(this)
  //       .parents('.activity-item-content')
  //       .outerHeight(endHeight)
  // })

  $('.endorsed-modal-trigger').on('click', function () {
    $('.endorsed-modal').fadeIn()
  })

  $('.loved-modal-trigger').on('click', function () {
    $('.endorsed-modal-' + $(this).data('id')).fadeIn()
  })

  $('.endorsed-modal-close, .endorsed-modal-shade').on('click', function () {
    $('.endorsed-modal').fadeOut()
    $('.search-modal')
        .hide()
        .removeClass('hide')
    $('.profile-sidebar-inner').removeClass('modal-open')
  })

  $('.gallery-modal-close').on('click', function () {
    $('.gallery-modal').fadeOut()
  })

  /*******************
   *
   * Review Modal
   *
   *******************/


  // if (document.getElementById('js-dropzone')) {
  //   new Vue({
  //     el: '#js-dropzone',
  //     components: {'form-dropzone': FormDropzone},
  //   })
  // }

  $('.review-filter-dd-close').on('click', function () {
    $(this)
        .parents('.activity-filter-dd')
        .fadeOut()
  })

  $('.review-filter-dd-shade').on('click', function () {
    $('.review-filter-dd-close').click()
  })

  $('.review-filter-trigger').on('click', function () {
    $(this)
        .next('.review-filter-dd')
        .fadeIn()
  })

  $('.reviews-nav > span, .js-review-tab').on('click', function () {
    var dat = $(this).data('id')
    var total
    var title
    var prevHeight = $('.activity-feed-single.active').height()
    var newHeight = $('#activity-feed-' + dat).height()

    if ($(this).data('total')) {
      $('#mob-activity-total').text($(this).data('total'))
    }

    if ($(this).data('title')) {
      $('#mob-activity-title').text($(this).data('title'))
    }

    $('.activity-filter-dd').fadeOut()

    $('.activity-feed-wrap').height(prevHeight)
    $(this)
        .addClass('active')
        .siblings()
        .removeClass('active')
    $('#activity-feed-' + dat)
        .addClass('active')
        .siblings()
        .removeClass('active')
    $('.activity-feed-wrap').height(newHeight)

    if (!$('.activity-feed-single.active').find('.hide').length) {
      $('.activity-feed-load-more').hide()
    } else {
      $('.activity-feed-load-more').show()
    }

    stickMe()
    setTimeout(stickMe, 150)
    setTimeout(stickMe, 301)
  })

  $('.review-feed-load-more').on('click', function () {
    var counter = 0

    $('.activity-feed-wrap').height($('.activity-feed-wrap').height())

    $('.activity-feed-single.active')
        .find('.hide')
        .each(function () {
          if (counter < 5) {
            counter++
            $(this).removeClass('hide')
          }
        })

    if (!$('.activity-feed-single.active').find('.hide').length) {
      $(this).hide()
    }

    $('.activity-feed-wrap').height($('.activity-feed-single.active').height())
  })

  $('.grid-dd-mob-modal-close, .grid-dd-mob-modal > .shade').on('click', function () {
    $('.grid-dd-mob-modal').fadeOut()
  })

  $('.grid-dd-mob').on('click', function () {
    $(this).next().fadeIn()
  })

  // $('.endorse-button').on('click', function () {
  //   var slug = $(this).data('slug')
  //   let token = document
  //       .querySelector('meta[name="csrf-token"]')
  //       .getAttribute('content')
  //   var endorseNum =
  //       parseInt(
  //           $(this)
  //               .find('small')
  //               .text()
  //       ) || 0
  //   var parReview = false
  //
  //   if ($(this).parents('.review-modal').length) {
  //     parReview = true
  //   }
  //
  //   if (!$(this).hasClass('active')) {
  //     if (typeof gtag === 'function') {
  //       gtag('event', 'click', {
  //         event_category: 'endorse',
  //         event_label: slug,
  //       })
  //     }
  //   }
  //
  //   // fetch(`/recommendation/${slug}/endorse`, {
  //   //   method: 'GET',
  //   //   credentials: 'include',
  //   //   headers: {'Content-Type': 'application/json', 'X-CSRF-TOKEN': token},
  //   // })
  //   //     .then(res => res.json())
  //   //     .then(res => {
  //   //       if (res['endorsed'] == 'false') {
  //   //         $('.endorse-button').removeClass('active')
  //   //
  //   //         if (endorseNum === 1 || endorseNum === 0) {
  //   //           $('.endorse-button small').text('')
  //   //         } else {
  //   //           $('.endorse-button small').text(endorseNum - 1)
  //   //         }
  //   //
  //   //         if (!parReview) {
  //   //           $('.review-modal-intro').show()
  //   //           $('.review-modal-intro.alt').hide()
  //   //           $('.review-modal-endorse').show()
  //   //           $('.js-endorse-close').text('Take me back')
  //   //         }
  //   //       }
  //   //
  //   //       if (res['endorsed'] == 'true') {
  //   //         $('.endorse-button').addClass('active')
  //   //         $('.endorse-button small').text(endorseNum + 1)
  //   //
  //   //         if (!parReview) {
  //   //           $('.review-modal-intro').hide()
  //   //           $('.review-modal-intro.alt').show()
  //   //           $('.review-modal-endorse').hide()
  //   //           $('.js-endorse-close').text('Take me back')
  //   //           $('.reviews-modal-trigger').click()
  //   //         }
  //   //       }
  //   //     })
  // })

  if ($('.user-lists-item').length) {
    $('.user-lists-item').hover(
        function () {
          var $this = $(this)

          if ($this.find('img.user-lists-hover').length) {
            $this.find('img.user-lists-original').hide()
            $this.find('img.user-lists-hover').css('display', 'block')
          }
        },
        function () {
          var $this = $(this)

          if ($this.find('img.user-lists-hover').length) {
            $this.find('img.user-lists-hover').hide()
            $this.find('img.user-lists-original').css('display', 'block')
          }
        }
    )
  }

  $('.profile-scroll-trigger').on('click', function (e) {
      alert('')
      e.preventDefault()
      var dat = $(this).data('id')
      var tar = $('.activity-header').offset().top - $('.main-header').outerHeight()

      if (window.viewport().width < 1080 && window.viewport().width > 800) {
          tar =
              $('.activity-header-mob').offset().top - $('.main-header').outerHeight()
      }

      if (window.viewport().width <= 800) {
          tar = $('.activity-header-mob').offset().top - $('.mobile-menu').first().outerHeight() - 20
      }

      // $('#activity-header-' + dat).click()

      // talk to vue to set the active feed in the ProfileFeed Component
      // window.detailFeed.updateActiveFeed(dat)

      $('html,body').animate({scrollTop: tar,}, 500)
  })

  $(document).on('click', '.pw-gate .login-cta', function () {
    $('.paywall-content').fadeOut(function () {
      $('.paywall-login').fadeIn()
    })
  })

  $(document).on('click', '.pw-gate .register-cta', function () {
    $('.paywall-content').fadeOut(function () {
      $('.paywall-apply').fadeIn()
    })
  })

  $(document).on('click', '.paywall-to-password', function () {
    $('.paywall-apply').fadeOut()

    $('.paywall-login').fadeOut(function () {
      $('.paywall-password').fadeIn()
    })
  })

  $(document).on('click', '.paywall-to-apply', function () {
    $('.paywall-password').fadeOut()

    $('.paywall-login').fadeOut(function () {
      $('.paywall-apply').fadeIn()
    })
  })

  $(document).on('click', '.paywall-to-login', function () {
    $('.paywall-apply').fadeOut()

    $('.paywall-password').fadeOut(function () {
      $('.paywall-login').fadeIn()
    })
  })

  $('.login-trigger').on('click', function () {
    $('.modal.login').addClass('is-open')
  })

  $(document).on('click', '[data-modal]', function (e) {
    e.preventDefault()
    $(this)
        .parents('.modal')
        .removeClass('is-open')
    $('.modal.' + $(this).data('modal')).addClass('is-open')
  })

  $('.scroll-to-review').on('click', function () {
      var tar = $('.reviews-section').offset().top - $('.main-header').outerHeight() + 1
      $('.extras-modal-close').click()

      $('body, html').animate({scrollTop: tar,}, 500)
  })

  new ClipboardJS(
      '.rec-extras .link-cta, .extras-modal .link-cta, .rec-copy-trigger, .list-copy-trigger, .list-copy-map-trigger'
  )
  $('.rec-extras .link-cta, .extras-modal .link-cta').on('click', function () {
    var $this = $(this)
    $this.next().addClass('active')
    setTimeout(function () {
      $this.next().removeClass('active')
    }, 3000)
  })

  $('.rec-copy-trigger').on('click', function () {
    $(this)
        .find('span')
        .text('Copied!')
  })

  $('.list-copy-map-trigger').on('click', function () {
    var $this = $(this)
    $this.find('.save-button-tooltip').addClass('active')

    setTimeout(function () {
      $this.find('.save-button-tooltip').removeClass('active')
    }, 3000)
  })

  var itemMover
  //var itemMovedBacker;

  $(document).on('mouseenter', '.hp-hero-feed .item-wrap', function () {
    var $this = $(this)
    var tarWidth = $this.prop('scrollWidth')
    var parWidth = $this.parent().outerWidth()
    var diff = tarWidth - parWidth
    var counter = parseInt($this.css('margin-left')) * -1

    if (window.viewport().width > 960) {
      if (tarWidth > parWidth) {
        itemMover = setInterval(function () {
          $this.css('margin-left', '-' + counter + 'px')
          counter += 1

          if (counter > diff) {
            clearInterval(itemMover)
          }
        }, 20)
      }
    }
  })

  $(document).on('mouseleave', '.hp-hero-feed .item-wrap', function () {
    var $this = $(this)
    var tarWidth = $this.prop('scrollWidth')
    var parWidth = $this.parent().outerWidth()
    var diff = tarWidth - parWidth
    var counter = parseInt($this.css('margin-left')) * -1

    if (window.viewport().width > 960) {
      clearInterval(itemMover)

      if (tarWidth > parWidth) {
        var itemMoverBacker = setInterval(function () {
          $this.css('margin-left', '-' + counter + 'px')
          counter -= 1

          if (counter < 0) {
            clearInterval(itemMoverBacker)
          }
        }, 5)
      }
    }
  })

  $(document).on('keydown', function (e) {
    if ($('.search-modal').css('display') == 'block') {
      if (e.keyCode == '27') {
        $('.search-close').click()
      }
    }

    if ($('.gallery-modal').css('display') == 'block') {
      if (e.keyCode == '27') {
        $('.gallery-modal-close').click()
      }

      if (e.keyCode == '37') {
        $('.gallery-modal-prev').click()
      }

      if (e.keyCode == '39') {
        $('.gallery-modal-next').click()
      }
    }
  })

  $(document).on('click', '.search-people-trigger', function () {
    $('.search-modal').addClass('hide')
    $('.search-trigger').removeClass('active')
  })

  $('.rec-share a, .extras-modal .socials a').on('click', function (event) {
    if ($(this).hasClass('copy-link')) return false

    var link = this.href

    var width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        url = link,
        opts =
            'status=1' +
            ',width=' +
            width +
            ',height=' +
            height +
            ',top=' +
            top +
            ',left=' +
            left

    window.open(url, 'twitter', opts)

    return false
  })

  function mobDestinationCheck() {
    var par = $('.cities-trigger > span')
    var tar = $('#destination-mob')

    if (tar.outerWidth() >= par.outerWidth() - 20) {
      $('.cities-trigger').addClass('wide')
    }
  }

  //FUNCTIONS TO RUN IMMEDIATELY
  mobileMoves()

  if ($('.mobile-menu .cities-trigger').length) {
    mobDestinationCheck()
  }

  //FUNCTIONS ON LOAD
  // $(window).on('load', function () {

  if ($('.city-intro').length) {
    cityMarqueeCheck()
    destinationMarquee()
  }

  if ($('.sticky').length && window.viewport().width > 960) {
    stickMe()
  }

  if ($('.desktop-cities:not(.no-move)').length && window.viewport().width <= 600) {
    moveTrendingCities()
  }

  if ($('.hp-hero-feature').length && window.viewport().width <= 960) {
    heroSliderInit()
  }

  if ($('.rec-gallery').length) {
    recSliderInit()
    hideRecButtons()
  }

  if ($('.rec-extras').length) {
    stickExtras($('.rec-extras-inner'))
  }

  if ($('.profile-content-extra').length) {
    stickExtras($('.profile-content-extra-inner'))
  }

  if ($('.reviews-scores').length) {
    $('.review-bar').each(function () {
      var dat = $(this).data('percentage')
      $(this)
          .find('.inner-bar')
          .css('width', dat + '%')
    })
  }
  // })

  $(window).on('scroll', function () {
    if ($('.sticky').length && viewport().width > 960) {
      stickMe()
    }

    if ($('.rec-extras').length) {
      stickExtras($('.rec-extras-inner'))
      hideRecButtons()
    }

    if ($('.profile-content-extra').length) {
      stickExtras($('.profile-content-extra-inner'))
    }

    // if ($('.account-item-list').length) {

    //   accountScrollWatch();

    // }
  })

  //FUNCTIONS ON RESIZE
  $(window).on('resize', function () {
    mobileMoves()

    if ($('.sticky').length && window.viewport().width > 960) {
      stickMe()
    }

    if ($('.desktop-cities').length && window.viewport().width <= 600) {
      moveTrendingCities()
    }

    if ($('.hp-hero-feature').length && window.viewport().width <= 960) {
      heroSliderInit()
    }

    if ($('.city-intro').length) {
      cityMarqueeCheck()
    }

    if ($('.mobile-menu .cities-trigger').length) {
      mobDestinationCheck()
    }
  })

  function mobCitiesInit() {
    $('.mob-cities-inner ul').each(function () {
      if ($(this).offset().top != $('.mob-cities-inner').offset().top) {
        $(this).addClass('line')
      }
    })
  }

  // $('.user-lists-modal__shade, .user-lists-modal__close').on('click', function () {
  //   $('.user-lists-modal').fadeOut()
  // })

  if ($('body').hasClass('map-page')) {
    $('.main-footer').appendTo('.map-sidebar')
  }

  $('.my-network-trigger').on('click', function () {
    $('.referrals-modal').fadeIn()
  })

  $('body').on('click', '.map-more-tags-trigger', function () {
    if (window.viewport().width < 961) {
      $(this).toggleClass('active')
    }
  })

  $('body').on('click', '.activity-item-comments-toggle', function () {
    $(this)
        .parent()
        .next()
        .slideToggle()
  })



  // $('.list-modal-new-trigger').on('click', function () {
  //   $(this)
  //       .siblings()
  //       .addClass('dis')
  //   $('.list-modal-submit').addClass('dis')
  //   $('.new-list-inputs').slideDown()
  // })

  // $('.add-to-list-modal__main .form__field--select').on('click', function () {
  //   if ($(this).hasClass('dis')) {
  //     $(this).removeClass('dis')
  //     $('.new-list-inputs').slideUp()
  //   }
  // })

  // $('.add-to-list-modal select').on('change', function () {
  //   $('.list-modal-submit').removeClass('dis')
  // })
  //
  // $('.add-to-list-modal input').on('keydown', function () {
  //   $('.list-modal-submit').removeClass('dis')
  // })

  // $('.add-to-list-close, .add-to-list-modal__shade').on('click', function () {
  //   $('.add-to-list-modal').fadeOut()
  // })

  // var openedLists = false

  // $(document).on('click', '.list-add-trigger', function (e) {
  //   addToListRecId = $(this).data('id')
  //   addToListRecTitle = $(this).data('title')
  //   addToListVm.$refs.addToListComponent.updateTitle(addToListRecTitle)
  //
  //   if (!openedLists) openedLists = true
  //   else addToListVm.$refs.addToListComponent.fetchUserLists()
  //
  //   $('.add-to-list-modal').fadeIn()
  // })

  $(document).on('click', '.list-map-empty__discover', function () {
    $(this).toggleClass('active')
  })

  var lastScrollTop = 0
  window.addEventListener('scroll', function () {
    var st = window.pageYOffset || document.documentElement.scrollTop
    // if($('.mob-cities').css("display") == "block" ){
    //   return
    // }
    if (st > lastScrollTop) {
      $('.gate-mobile-menu')
          .addClass('inactive')
          .siblings()
          .removeClass('inactive')
    } else {
      $('.mobile-menu')
          .addClass('inactive')
          .siblings()
          .removeClass('inactive')
    }
    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }, false)

  //How it works "Gate" code
  if ($('body').hasClass('gate')) {
    //GateHeroModule.init();

    GateStepsModule.init()

    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();

    LoginModule.init()

    if ($('.cities__slider .marquee-wrap').length) {
      $('.marquee-wrap').marquee({
        //duration in milliseconds of the marquee
        duration: 20000,
        //gap in pixels between the tickers
        gap: 0,
        //time in milliseconds before the marquee will start animating
        delayBeforeStart: 0,
        //'left' or 'right'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
        startVisible: true,
      })
    }
  }

  // Modal opening and closing
  function openModal(type) {
    $('.modal').each(function () {
      if ($(this).hasClass(type)) {
        $(this).addClass('is-open')
        $('body').addClass('no-scroll')
      }
    })
  }

  function closeModal() {
    $('.modal').removeClass('is-open')
    $('body').removeClass('no-scroll')
  }

if(is_logged_in) {
  $('[data-modal]').on('click', function (e) {
    e.preventDefault()

    var type = $(this).data('modal')

    var isOtherFormButton = $(this).closest('.form').length

    if ($('.modal').hasClass('is-open') && !isOtherFormButton) {
      closeModal()
    } else {
      if (isOtherFormButton) {
        closeModal()
      }

      openModal(type)
    }
  })
}

  $('.modal__overlay, .modal__close').on('click', function () {
    closeModal()
  })

  $(document).on('keydown', function (event) {
    if (event.key == 'Escape') {
      closeModal()
    }
  })

  var firstGateText = true

  if ($('.gate-hero__posts').length) {
    initGateText()
  }

  function initGateText() {
    var $sentence = $('#change-text')
    var newContent = ''

    //go through all characters of the sentence
    for (i = 0; i < $sentence.text().length; i++) {
      var substring = $sentence.text().substr(i, 1)
      //if we have a character, wrap it
      if (substring != ' ') {
        if (firstGateText) {
          newContent += '<span>' + substring + '</span>'
        } else {
          newContent += '<span class="inactive">' + substring + '</span>'
        }
      } else {
        newContent += substring
      }
    }
    //replace content
    $sentence.html(newContent)

    if (firstGateText) {
      firstGateText = false
      setInterval(triggerGateText, 4000)
    } else {
      reverseGateText()
    }
  }

  function reverseGateText() {
    var $sentence = $('#change-text')

    var $spans = $sentence.find('span')
    var spanCounter = 0
    var spanDelay = 30
    var transLength = $spans.length * spanDelay + 700

    $('.change-text-wrap').animate(
        {
          width: $('#change-text').width() + 'px',
        },
        500
    )

    setTimeout(function () {
      $spans.each(function () {
        var $span = $(this)
        setTimeout(function () {
          $span.toggleClass('inactive')
        }, spanCounter * spanDelay)

        spanCounter++
      })
    }, 100)
  }

  function triggerGateText() {
    var $sentence = $('#change-text')

    var $spans = $sentence.find('span')
    var spanCounter = 0
    var spanDelay = 60
    var transLength = $spans.length * spanDelay + 700

    $($spans.get().reverse()).each(function () {
      var $span = $(this)
      setTimeout(function () {
        $span.toggleClass('inactive')
      }, spanCounter * spanDelay)

      spanCounter++
    })

    if (spanCounter >= $spans.length) {
      setTimeout(function () {
        $('.change-text-wrap').animate(
            {
              width: '0',
            },
            transLength
        )
      }, 150)

      setTimeout(nextGatePost, transLength + 151)
    }
  }

  function nextGatePost() {
    var current = $('.gate-hero-item.next-up')
    var next = $('.gate-hero-item.last-up')
    var last = $('.gate-hero-item.current-up')
    var id = current.data('item')
    var text = current.data('text')

    if ($('#about-changer-words').length) {

      current = $('#about-changer-words .active').removeClass('active');
      next = current.next().addClass('active');

      if (!next) {

        next = $('#about-changer-words li').first().addClass('active');

      }

      text = next.text();
      $('#change-text').text(text);

    } else {

      $('#change-text').text(text)
      setTimeout(initGateText, 100)
      current.removeClass('next-up').addClass('current-up')
      next.removeClass('last-up').addClass('next-up')
      last.removeClass('current-up').addClass('last-up')
      $('#gate-bg-' + id)
          .addClass('active')
          .siblings()
          .removeClass('active')

    }
  }

  if ($('.map-post').length && viewport().width < 961) {
    $('.map-post a').on('click touchend', function (e) {
      var el = $(this)
      var link = el.attr('href')
      var scroll = $(window).scrollTop()
      var img = $(this).find('img')
      var imgOffset = img.offset().left || false

      e.preventDefault()

      setTimeout(function () {
        if ($(window).scrollTop() != scroll) {
          //console.log('scrolling');
        } else {
          //console.log('not scrolling');

          if (img) {
            if (img.offset().left == imgOffset) {
              // console.log('triggered 1')
              window.location = link
            }
          } else {
            // console.log('triggered 2')
            window.location = link
          }
        }
      }, 500)
    })
  }

  if ($('#hp-lists-slider').length) {
    $('#hp-lists-slider').slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      appendArrows: $('#hp-lists-controls'),
      rows: 0,
      infinite: false,
      prevArrow:
          '<span class="slick-prev"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      nextArrow:
          '<span class="slick-next"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
          },
        },
      ],
    })
  }

  if ($('#hp-follow-slider').length) {
    $('#hp-follow-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      appendArrows: $('#hp-follow-controls'),
      rows: 0,
      infinite: false,
      prevArrow: '<span class="slick-prev"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      nextArrow: '<span class="slick-next"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2.45,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2.08,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 440,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    })
  }

  $('.dismiss-follow').on('click', function () {
    var par = $(this).parents('.hp-follow')
    var slideIndex = par.index()
    var dist = par.outerWidth() + parseInt(par.css('margin-right'))
    var next = par.nextAll('.hp-follow')
    var total = $('.hp-follow').length
    var lastIndexes = 4

    if (window.viewport().width < 601) {
      lastIndexes = 2
    }

    if (slideIndex + 1 > total - lastIndexes && total > lastIndexes) {
      next = par.prevAll('.hp-follow')

      par.animate(
          {
            opacity: 0,
          },
          300,
          function () {
            next.animate(
                {
                  right: dist * -1,
                },
                300
            )

            setTimeout(function () {
              $('.hp-follow').css('right', '0')
              $('#hp-follow-slider').slick('slickRemove', slideIndex)
            }, 500)
          }
      )
    } else {
      par.animate(
          {
            opacity: 0,
          },
          300,
          function () {
            next.animate(
                {
                  left: dist * -1,
                },
                300
            )

            setTimeout(function () {
              $('.hp-follow').css('left', '0')
              $('#hp-follow-slider').slick('slickRemove', slideIndex)
            }, 500)
          }
      )
    }

    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    })

    $.ajax({
      url: '/dismiss-user',
      type: 'POST',
      data: {
        user: $(this).data('id'),
      },
      success: function (data) {
      },
    })
  })

  $('.hp-item-menu-trigger').on('click', function () {
    $(this)
        .next()
        .addClass('active')
  })

  if ($('.hp-testimonails-slider').length) {
    $('.hp-testimonails-slider').slick({
      fade: true,
      prevArrow:
          '<span class="slick-prev"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      nextArrow:
          '<span class="slick-next"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            dots: true,
          },
        },
      ],
    })
  }

  // $('.price').on('click', function () {
  //   $(this).toggleClass('active')
  // })



  if (!is_logged_in) {
    $(document).on('click', '.person-hover-trigger', function (e) {
      return false;
    });
  }

  //Edit FROM Profile

  $('.profile-intro-edit button').on('click', function (e) {
    e.preventDefault()

    var tar = $(this).next()

    tar.focus()
  })

  $('.profile-questions-empty-cta').on('click', function () {
    $(this)
        .hide()
        .siblings()
        .show()
    $(this)
        .parents('.profile-questions-empty__question')
        .find('textarea')
        .slideDown()
        .focus()
  })

  $('.profile-questions-empty-close').on('click', function () {
    $(this)
        .hide()
        .siblings()
        .show()
    $(this)
        .parents('.profile-questions-empty__question')
        .find('textarea')
        .slideUp()
  })

  $('.profile-questions-empty-select').on('change', function () {
    var val = $(this)
        .find('option:selected')
        .text()
    $(this)
        .siblings('span')
        .text(val)
    $('.profile-questions-empty-close').show()
    $('.profile-questions-empty-cta').hide()
    $(this)
        .parents('.profile-questions-empty__question')
        .find('textarea')
        .slideDown()
        .focus()
  })

  $('.profile-questions-empty__question textarea').on('keyup', function () {
    var val = $(this).val()

    if (val != '') {
      $(this).addClass('updated')
    } else {
      $(this).removeClass('updated')
    }

    $('#empty-question-count').text($('textarea.updated').length)

    if ($('textarea.updated').length > 0) {
      $('.profile-questions-empty__footer').slideDown()
    } else {
      $('.profile-questions-empty__footer').slideUp()
    }
  })

  $('.profile-intro-edit input').on('keydown touchend', function () {
    $('.profile-intro-edit-submit').slideDown()
    $(this).focus()
  })

  $('.profile-intro-edit button').on('click', function () {
    $('.profile-intro-edit input').show().focus();
    $('.profile-intro-edit span').hide();
  })

  $(window).on('load', function () {
    // if ($('#membership-image').length) {
    //   var num = window.viewport().height - ($('.how-hero__top').outerHeight() + $('.main-header').outerHeight());
    //   if (window.viewport().width <= 800) {
    //     num = window.viewport().height - ($('.how-hero__top').outerHeight() + $('.mobile-menu').outerHeight());
    //   }
    //   $('#membership-image').outerHeight(num);
    // }
  })

  $('.header-notifications-trigger, .notifications-trigger').on('click', function () {
      $(this).toggleClass('active')
      $('.notification-centre').fadeToggle()
      // console.log(window.notificationsCenter)
      window.notificationsCenter.showNotifications()
      if (window.viewport().width < 801) {
          $('.search-modal').fadeOut();
      }
  })

  $('.notification-slide-next').on('click', function () {
    var cur = $('.notification-slide.active').data('slide')
    var next = cur + 1

    // console.log($('.notification-slide').length)

    if (next > $('.notification-slide').length) {
      next = 1
    }

    $('#notification-track-' + next + ', #notification-slide-' + next)
        .addClass('active')
        .siblings()
        .removeClass('active')
  })

  $('.notification-slide-prev').on('click', function () {
    var cur = $('.notification-slide.active').data('slide')
    var next = cur - 1

    // console.log($('.notification-slide').length)

    if (next < 1) {
      next = 5
    }

    $('#notification-track-' + next + ', #notification-slide-' + next)
        .addClass('active')
        .siblings()
        .removeClass('active')
  })

  $('.notification-centre-track span').on('click', function () {
    var dat = $(this).data('slide')

    $(this)
        .addClass('active')
        .siblings()
        .removeClass('active')
    $('#notification-slide-' + dat)
        .addClass('active')
        .siblings()
        .removeClass('active')
  })

  $('.notification-slide.final .cta').on('click', function () {
    $('.notification-centre__main').removeClass('w-setup')
    $('.notification-centre__setup').addClass('hide')

    axios
        .post('/completed-account-setup', {})
        .then(res => console.log(res))
        .catch(err => console.err(err))
  })

  $('.notification-centre-mob-trigger').on('click', function () {
    var dat = $(this).data('id')
    $(this)
        .addClass('active')
        .siblings()
        .removeClass('active')

    if (dat == 1) {
      $('.notification-centre__setup').removeClass('hide')
    } else {
      $('.notification-centre__setup').addClass('hide')
    }
  })

  $('.congrats-close').on('click', function () {
    $('.congrats-modal').fadeOut()
  })

  $('.congrats-slideshow-prev').on('click', function () {
    congratsSlideChange(-1)
  })

  $('.congrats-slideshow-next').on('click', function () {
    congratsSlideChange(1)
  })

  function congratsSlideChange(dir) {

    var curSlide = $('.congrats-modal__slideshow .slide.active');
    var nextSlide;

    if (dir == -1) {

      $('.congrats-slideshow-next').removeClass('dis');

      if (curSlide.prev().length) {

        nextSlide = curSlide.prev();
        $('.congrats-modal__slideshow .main-controls').addClass('active');
        $('.congrats-modal__slideshow .cta-controls').removeClass('active');

        if (nextSlide.is(':first-child')) {

          $('.congrats-slideshow-prev').addClass('dis');

        }

      }

    } else {

      $('.congrats-slideshow-prev').removeClass('dis');

      if (curSlide.next().length) {

        nextSlide = curSlide.next();

        if (nextSlide.is(':last-child')) {

          $('.congrats-slideshow-next').addClass('dis');
          $('.congrats-modal__slideshow .main-controls').removeClass('active');
          $('.congrats-modal__slideshow .cta-controls').addClass('active');

        }

      }

    }

    $('#congrats-slideshow-current').text(nextSlide.data('slide'));
    $('#congrats-slideshow-dot-' + nextSlide.data('slide')).addClass('active').siblings().removeClass('active');
    curSlide.removeClass('active');
    nextSlide.addClass('active');

    if ($('.congrats-modal__slideshow .slide').last().hasClass('active')) {

      $('.congrats-modal__close').addClass('active');

    } else {

      $('.congrats-modal__close').removeClass('active');

    }

  }

  $('.congrats-dot').on('click', function () {

    var slide = $(this).data('slide');
    $('#congrats-slide-' + slide).addClass('active').siblings().removeClass('active');
    $(this).addClass('active').siblings().removeClass('active');

    if (slide == 1) {

      $('.congrats-slideshow-prev').addClass('dis');
      $('.congrats-slideshow-next').removeClass('dis');
      $('.congrats-modal__slideshow .main-controls').addClass('active');
      $('.congrats-modal__slideshow .cta-controls').removeClass('active');

    } else if (slide == 4) {

      $('.congrats-slideshow-next').addClass('dis');
      $('.congrats-slideshow-prev').removeClass('dis');
      $('.congrats-modal__slideshow .main-controls').removeClass('active');
      $('.congrats-modal__slideshow .cta-controls').addClass('active');

    } else {

      $('.congrats-slideshow-next').removeClass('dis');
      $('.congrats-slideshow-prev').removeClass('dis');
      $('.congrats-modal__slideshow .main-controls').addClass('active');
      $('.congrats-modal__slideshow .cta-controls').removeClass('active');

    }

  });

  $('.congrats-slideshow-start').on('click', function () {

    $('.congrats-modal__slideshow').fadeIn();

  });

  $('.verified-spot').on('click', function () {
    if (window.viewport().width < 961) {
      $(this).toggleClass('active')
    } else {
      $(this).removeClass('active')
    }
  })

  if ($('.confetti-wrap').length) {
    var canvas = document.getElementById('confetti-canvas')

    var count = 200
    var defaults = {
      origin: {y: 0.5},
      gravity: 0.7,
      shapes: ['square'],
      colors: ['#FFC296', '#ACDDF4', '#F5C9D1'],
      startVelocity: 25,
    }

    canvas.confetti =
        canvas.confetti || confetti.create(canvas, {resize: true})

    function fire(particleRatio, opts) {
      canvas.confetti(
          Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio),
          })
      )
    }

    var confettiCount = 0
    var confettiInterval = setInterval(function () {
      fire(0.25, {
        spread: 26,
        //startVelocity: 25,
      })
      fire(0.2, {
        spread: 60,
      })
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      })
      fire(0.1, {
        spread: 120,
        //startVelocity: 15,
        decay: 0.92,
        scalar: 1.2,
      })
      fire(0.1, {
        spread: 120,
        //startVelocity: 20,
      })

      confettiCount++

      // if (confettiCount > 5) {
      //     clearInterval(confettiInterval);

      // }
    }, 3000)
  }

  // $('.account-founder-renew-trigger').not('on-vue').on('click', function () {
  //
  //   $(this).toggleClass('swap');
  //   $('.account-founder-renew .full-content').slideToggle();
  //
  // });

  $('.faq-page__item').on('click', function () {

    $(this).toggleClass('active').find('.hidden-content').slideToggle();

  });


  $('.blog-nav-browse-trigger').on('click', function () {
    // $('.modal--success .modal__close').on('click', function() {
    $(this).toggleClass('active').next().fadeToggle();

  });

  if (window.viewport().width > 800) {
    $('.blog-popular__slider').slick({
      slidesToShow: 2.6,
      slidesToScroll: 2,
      rows: 0,
      infinite: false,
      prevArrow: '#blog-popular-prev',
      nextArrow: '#blog-popular-next',
    });
  }


  if ($('.destination-blog__slider').length) {

    if ($('.destination-blog__slider .slider-post').length > 2) {

      if (window.viewport().width > 960) {

        $('.destination-blog__slider').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 0,
          infinite: false,
          prevArrow: '#destination-blog-prev',
          nextArrow: '#destination-blog-next',
        });

      }

    } else {

      $('.destination-blog').addClass('no-slider');

    }

  }

  if ($('.city-hotels__slider').length) {

    if ($('.city-hotels__slider .slider-post').length > 2) {

      if (window.viewport().width > 960) {

        $('.city-hotels__slider').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 0,
          infinite: false,
          prevArrow: '#city-hotels-prev',
          nextArrow: '#city-hotels-next',
        });

      }

    } else {

      $('.city-hotels-blog').addClass('no-slider');

    }

  }


  $('.blog-latest-trigger').on('click', function () {

    var tar = $(this).data('tar');
    var url = $(this).data('url');

    $('#blog-latest-title').text($(this).text());
    $('#blog-latest-' + tar).addClass('active').siblings().removeClass('active');
    $('.blog-latest-view-all').attr('href', url);

  });

  $(".blog-latest__title .dd-wrap").on('click', function () {

    $(this).toggleClass('open');

  });

  if ($('.multi-post-widget').length) {

    $('.map-post').each(function () {

      var $this = $(this);

      $this.find('.slides-wrap').on('beforeChange', function (event, slick, oldSlideIndex, newSlideIndex) {

        var dotDistance = 0;

        if (newSlideIndex > 1) {

          if (newSlideIndex == slick.slideCount - 1) {

            dotDistance = (newSlideIndex - 2) * -10;

          } else {

            dotDistance = (newSlideIndex - 1) * -10;

          }

        } else {

          dotDistance = 0;

        }

        $this.find('.custom-dot').css('transform', "translateX(" + dotDistance + "px)");

      });

      $this.find('.slides-wrap').slick({
        slidesToShow: 1,
        dots: true,
        lazyLoad: 'ondemand',
        prevArrow: $this.find('.slick-prev'),
        nextArrow: $this.find('.slick-next'),
        customPaging: function (slider, i) {
          return '<div class="custom-dot"></div>';
        },
      })

    });

  }

  if ($('.blog-single__comments').length) {

    $('.activity-item-comments-toggle').on('click', function () {

      $(this).toggleClass('active');

    });

    $('.activity-item-heart-toggle').on('click', function () {

      $(this).find('svg').toggleClass('active');

      if ($(this).find('svg').hasClass('active')) {

        $(this).find('small').text(parseInt($(this).find('small').text()) + 1);

      } else {

        $(this).find('small').text(parseInt($(this).find('small').text()) - 1);

      }

    });


  }

  $('.blog-comment-cta').on('click', function () {

    $('html, body').animate({

      scrollTop: $('.blog-main-comment-form').offset().top,

    }, 1000);

    $('.blog-main-comment-form textarea').focus();

  });

  $('.nav-menu-trigger, .nav-menu__shade').on('click', function () {

    $('.nav-menu').fadeToggle();

  });

  $(document).on('click', '.search-tab-trigger', function () {

    var dat = $(this).data('tar');
    $(this).addClass('active').siblings().removeClass('active');
    $('#search-results-' + dat).addClass('active').siblings().removeClass('active');

  });

  $(document).on('click', '#blog-load-more', function () {

    $(this).html('Loading...');

    axios.post('/journal/load-more', $(this).data())
        .then((response) => {

          $(this).data('page', (response.data.current_page + 1));

          $(this).html('Load More');

          $('.blog-grid').last().find('.blog-grid__inner').append(response.data.content);

          if (!response.data.load_more){
            $(this).hide();
          }

        });

  });


})(jQuery)
